'use strict';

/** @type {import('./gOPD')} */
module.exports = Object.getOwnPropertyDescriptor;



//////////////////
// WEBPACK FOOTER
// ./node_modules/gopd/gOPD.js
// module id = ZdvT
// module chunks = 0